export default state => ({
  ...state,
  sdkFailure: true
});
